export const UPDATE_METADATA = `mutation UpdateMetadata($input: UpdateMetadataInput!){
    updateMetadata(input: $input){
        success
    }
}`;
